export const formatMSTDateCustom = (input: Date | string) => {
    const date = input instanceof Date ? input : new Date(input);

    if (Number.isNaN(date.getTime())) {
        return 'Invalid date';
    }

    const dateFormatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Phoenix',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });

    const timeFormatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Phoenix',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    });

    const formattedDate = dateFormatter.format(date);
    const formattedTime = timeFormatter.format(date);

    return `${formattedDate} at ${formattedTime} MST`;
};
